"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Removes ALL existing viewport-tags from the email and
 * appends the following viewport-tag to the most top-level <head> element
 * <meta name="viewport" content="width=device-width" />
 *
 * If the email does not contain a <head> element then it will be created
 * just before the viewport-tag gets appended.
 */
function enforceViewport($, desiredViewport) {
    if (desiredViewport === void 0) { desiredViewport = '<meta name="viewport" content="width=device-width">'; }
    var viewports = $('meta[name="viewport"]');
    var hasViewport = viewports.length > 0;
    var viewportElement = $(desiredViewport);
    if (hasViewport) {
        // remove current viewports
        viewports.each(function (_, el) {
            $(el).remove();
        });
    }
    // Insert a viewport
    var head = $('head'); // Cheerio already makes sure head is present
    head.append(viewportElement);
}
exports.default = enforceViewport;
